<!--
 * @Date: 2023-02-17 17:31:54
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-10 15:20:05
 * @FilePath: /nicee-web-tw/src/upgrade-page/views/new-user/research/index.vue
 * @Description: 新用户调研
-->
<template>
  <div class="new-user-research" v-loading="loading">
    <div>
      <div class="main">
        <div class="title">
          <img src="@/assets/image/icons/logo.png" alt="" />
          <span>{{$t('upgrade_page_views_new_user_research_index_2119')}}</span>
        </div>
        <el-form
          ref="form"
          :model="form"
          label-position="top"
          label-width="80px"
          :disabled="isSaving"
          :rules="rules"
        >
          <el-form-item
            :label="$t('upgrade_page_views_new_user_research_index_2120')"
            prop="source"
          >
            <el-input
              type="textarea"
              :rows="2"
              placeholder=""
              maxlength="30"
              show-word-limit
              v-model="form.source"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            :label="$t('upgrade_page_views_new_user_research_index_2121')"
            prop="cause"
          >
            <el-input
              type="textarea"
              :rows="2"
              placeholder=""
              maxlength="30"
              show-word-limit
              v-model="form.cause"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            :label="$t('upgrade_page_views_new_user_research_index_2122')"
            prop="suggestion"
          >
            <el-input
              type="textarea"
              :rows="2"
              placeholder=""
              maxlength="30"
              show-word-limit
              v-model="form.suggestion"
            >
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              class="btn-submit"
              :disabled="isSaving"
              v-loading="submitLoading"
              @click="submitForm"
              >{{ isSaving ? $t('upgrade_page_views_new_user_research_index_2123') : $t('upgrade_page_views_new_user_research_index_2124') }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex';

export default {
  name: 'NewUserResearch',
  props: {},
  data() {
    return {
      isSaving: false,
      loading: true,
      submitLoading: false,
      form: {
        source: '',
        cause: '',
        suggestion: ''
      },
      rules: {
        source: [{ required: true, message: i18n.t('upgrade_page_views_new_user_research_index_2125'), trigger: 'change' }],
        cause: [{ required: true, message: i18n.t('upgrade_page_views_new_user_research_index_2125'), trigger: 'change' }],
        suggestion: [{ required: true, message: i18n.t('upgrade_page_views_new_user_research_index_2125'), trigger: 'change' }]
      }
    };
  },
  watch: {
    // userInfo: {
    //   handler: function(nVal) {
    //     if (nVal) {
    //       this.getDetail();
    //     }
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isApp() {
      console.log(this.$route.query);
      try {
        return this.$route.query.isApp;
      } catch (error) {
        return false;
      }
    }
  },
  methods: {
    async getDetail() {
      try {
        await this.$store.dispatch('app/getUserInfo');
        this.$http.get('/user/research/isSave').then(({ data }) => {
          this.loading = false;
          this.isSaving = data;
          if (this.isSaving) {
            if (this.isApp) {
              this.isSaving = true;
              this.$message({
                message: i18n.t('upgrade_page_views_new_user_research_index_2126'),
                type: 'success',
                duration: 0,
                offset: 40
              });
            } else {
              this.$confirm({
                message: i18n.t('upgrade_page_views_new_user_research_index_2126'),
                title: i18n.t('upgrade_page_views_order_confirm_order_291'),
                showCancelButton: false,
                confirmButtonText: i18n.t('upgrade_page_layout_header_41'),
                closeOnClickModal: false,
                customClass: 'dialog-center'
              }).then(() => {
                this.$router.push({ path: '/home' });
              });
            }
          }
        });
      } catch (error) {
        if (!this.userInfo) {
          this.$util.Login({ redirect: this.$route.path }).then(() => {
            this.getDetail();
          });
          // this.$message('未登錄，不能領取');
        }
        console.log(error);
      }
    },
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid && !this.submitLoading) {
          this.submitLoading = true;
          this.$http
            .post('/user/research/save', {
              question1: this.form.source,
              question2: this.form.cause,
              question3: this.form.suggestion,
              userUuid: this.userInfo.uuid
            })
            .then(() => {
              if (this.isApp) {
                this.isSaving = true;
                this.$message({
                  message: i18n.t('upgrade_page_views_new_user_research_index_2127'),
                  type: 'success',
                  duration: 0,
                  offset: 40
                });
              } else {
                this.$confirm({
                  message: i18n.t('upgrade_page_views_new_user_research_index_2127'),
                  title: i18n.t('upgrade_page_views_order_confirm_order_291'),
                  showCancelButton: false,
                  confirmButtonText: i18n.t('upgrade_page_layout_header_41'),
                  closeOnClickModal: false,
                  customClass: 'dialog-center'
                }).then(() => {
                  this.$router.push({ path: '/home' });
                });
              }
            })
            .finally(() => {
              this.submitLoading = false;
            });
        } else {
          return false;
        }
      });
    }
  },
  created() {
    document.title = i18n.t('upgrade_page_views_new_user_research_index_2128');
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.new-user-research {
  font-size: 16px;
  display: flex;
  justify-content: center;
  .main {
    max-width: 750px;
    padding: 30px;
    border: 1px solid #e9e9e9;
    border-radius: 10px;
    margin: 40px 20px 30px;
    /deep/ .el-form-item__label {
      padding-bottom: 0;
    }
    /deep/.el-textarea__inner {
      &:focus {
        border: 1px solid #fed838;
      }
    }
    .btn-submit {
      width: 100%;
      color: black;
      font-weight: bold;
      margin-top: 20px;
    }
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px;
    font-weight: bold;
    img {
      width: 40px;
      height: auto;
      margin-right: 10px;
    }
  }
}
</style>
